import {
  COMMODITIES_TYPE,
  CURRENCY_TYPE_ID,
} from '@models/commodities.constant';

export interface ICommodityResponse {
  id: string;
  name: string;
  value: number;
  previous_close: number;
  variation_percentage: number;
  variation: number;
  volume: number;
  type_name: string;
  currency_type: string;
}

export interface ICommodityOldResponse {
  name: string;
  description: string;
  lastValue: number;
  closeValue: number;
  buyPrice: number;
  sellPrice: number;
  percentageChange: number;
  unitChange: number;
  volume: number;
  currencyType: number;
  commodityType: number;
}

export interface ICommodity {
  id: string;
  name: string;
  value: number;
  previousClose: number;
  variationPercentage: number;
  variation: number;
  volume: number;
  typeId: number;
  currencyType: number;
}

export class CommodityViewModel implements ICommodity {
  static fromJSON(json: ICommodityResponse): CommodityViewModel {
    const cleanTypeName = json.type_name && json.type_name.trim();
    const foundCommodity = COMMODITIES_TYPE[cleanTypeName];
    const typeId = (foundCommodity && foundCommodity.id) || 0;
    const currencyType =
      (CURRENCY_TYPE_ID as any)[json.currency_type] || CURRENCY_TYPE_ID.MXN;

    return new CommodityViewModel(
      json.id,
      json.name,
      json.value,
      json.previous_close,
      json.variation_percentage,
      json.variation,
      json.volume,
      typeId,
      currencyType,
    );
  }

  static fromOldJSON(json: ICommodityOldResponse): CommodityViewModel {
    return new CommodityViewModel(
      json.name,
      json.description,
      json.lastValue,
      json.closeValue,
      json.percentageChange,
      json.unitChange,
      json.volume,
      json.commodityType,
      json.currencyType,
    );
  }

  constructor(
    public id: string,
    public name: string,
    public value: number,
    public previousClose: number,
    public variationPercentage: number,
    public variation: number,
    public volume: number,
    public typeId: number,
    public currencyType: number,
  ) {}
}
